import apiClient from './axios';
import type { User } from '@cms/models';

/** Payload for POST /tenant-users (tenantId required). */
export type TenantUserCreatePayload = {
  tenantId: string;
  email: string;
  name?: string;
  password?: string;
  roleId?: string;
};
/** Payload for PATCH /tenant-users/:id */
export type TenantUserUpdatePayload = {
  name?: string;
  status?: string;
  roleId?: string | null;
  password?: string;
};

export type TenantUserListParams = {
  /** Omit or leave empty (platform) to list all tenant users across tenants. */
  tenantId?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  status?: string;
};

export type TenantUserListResponse = {
  data: User[];
  total: number;
};

export const tenantUserApi = {
  getList: async (
    params: TenantUserListParams
  ): Promise<TenantUserListResponse> => {
    const { tenantId, page = 1, pageSize = 25, search, status } = params;
    const trimmedTenantId = tenantId?.trim();
    const { data } = await apiClient.get<TenantUserListResponse>(
      '/tenant-users',
      {
        params: {
          ...(trimmedTenantId ? { tenantId: trimmedTenantId } : {}),
          page,
          pageSize,
          ...(search ? { search } : {}),
          ...(status ? { status } : {}),
        },
      }
    );
    return data;
  },

  getById: async (id: string): Promise<User> => {
    const { data } = await apiClient.get<User>(`/tenant-users/${id}`);
    return data;
  },

  create: async (body: TenantUserCreatePayload): Promise<User> => {
    const { data } = await apiClient.post<User>('/tenant-users', body);
    return data;
  },

  update: async (id: string, body: TenantUserUpdatePayload): Promise<User> => {
    const { data } = await apiClient.patch<User>(`/tenant-users/${id}`, body);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/tenant-users/${id}`);
  },
};
